import FormSlider from './FormSlider';

export default FormSlider;
